module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_600.74c3fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/fullscreen-image_lets-get_600.png
// module id = k3Hd
// module chunks = 0